export const appleOSdetectionMixin = {
    data() {
        return {
            macOS: false,
            IOS: false
        }
    },
    created() {
        this.macOS = navigator.appVersion.indexOf("Mac") != -1
        this.IOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
    }
}
